'use client';

import React, { useState, useMemo } from 'react';
import AppLayout from '@/components/AppLayout';
import DoctorsHeader from './components/DoctorsHeader';
import DoctorsFilters from './components/DoctorsFilters';
import DoctorsGrid from './components/DoctorsGrid';

export interface Doctor {
  id: string;
  name: string;
  specialization: string;
  department: string;
  qualification: string;
  experience: number;
  availability: 'Available' | 'In Surgery' | 'On Leave' | 'Off Duty' | 'In Consultation';
  patientLoad: number;
  maxPatients: number;
  rating: number;
  consultations: number;
  phone: string;
  email: string;
  joinDate: string;
  avatar: string;
  nextSlot: string;
  languages: string[];
}

const DOCTORS_DATA: Doctor[] = [
  {
    id: 'DOC-001', name: 'Dr. Priya Sharma', specialization: 'Cardiologist',
    department: 'Cardiology', qualification: 'MBBS, MD, DM (Cardiology)',
    experience: 14, availability: 'Available', patientLoad: 18, maxPatients: 25,
    rating: 4.9, consultations: 2847, phone: '+91 98765 43210',
    email: 'priya.sharma@medicore.hospital', joinDate: '2010-03-15',
    avatar: 'PS', nextSlot: '10:30 AM', languages: ['English', 'Hindi', 'Tamil'],
  },
  {
    id: 'DOC-002', name: 'Dr. Arjun Mehta', specialization: 'Neurologist',
    department: 'Neurology', qualification: 'MBBS, MD, DM (Neurology)',
    experience: 11, availability: 'In Consultation', patientLoad: 22, maxPatients: 25,
    rating: 4.8, consultations: 1923, phone: '+91 98765 43211',
    email: 'arjun.mehta@medicore.hospital', joinDate: '2013-07-01',
    avatar: 'AM', nextSlot: '2:00 PM', languages: ['English', 'Hindi', 'Gujarati'],
  },
  {
    id: 'DOC-003', name: 'Dr. Kavitha Iyer', specialization: 'Pediatrician',
    department: 'Pediatrics', qualification: 'MBBS, MD (Pediatrics)',
    experience: 9, availability: 'Available', patientLoad: 12, maxPatients: 30,
    rating: 4.9, consultations: 3102, phone: '+91 98765 43212',
    email: 'kavitha.iyer@medicore.hospital', joinDate: '2015-01-20',
    avatar: 'KI', nextSlot: '11:00 AM', languages: ['English', 'Tamil', 'Malayalam'],
  },
  {
    id: 'DOC-004', name: 'Dr. Rahul Nair', specialization: 'Orthopedic Surgeon',
    department: 'Orthopedics', qualification: 'MBBS, MS (Ortho), DNB',
    experience: 16, availability: 'In Surgery', patientLoad: 20, maxPatients: 20,
    rating: 4.7, consultations: 1654, phone: '+91 98765 43213',
    email: 'rahul.nair@medicore.hospital', joinDate: '2008-09-10',
    avatar: 'RN', nextSlot: '4:30 PM', languages: ['English', 'Hindi', 'Malayalam'],
  },
  {
    id: 'DOC-005', name: 'Dr. Aisha Khan', specialization: 'Oncologist',
    department: 'Oncology', qualification: 'MBBS, MD, DM (Oncology)',
    experience: 12, availability: 'Available', patientLoad: 15, maxPatients: 20,
    rating: 4.8, consultations: 1287, phone: '+91 98765 43214',
    email: 'aisha.khan@medicore.hospital', joinDate: '2012-05-22',
    avatar: 'AK', nextSlot: '9:00 AM', languages: ['English', 'Hindi', 'Urdu'],
  },
  {
    id: 'DOC-006', name: 'Dr. Suresh Patel', specialization: 'General Surgeon',
    department: 'General Surgery', qualification: 'MBBS, MS (General Surgery)',
    experience: 18, availability: 'Off Duty', patientLoad: 0, maxPatients: 22,
    rating: 4.6, consultations: 2341, phone: '+91 98765 43215',
    email: 'suresh.patel@medicore.hospital', joinDate: '2006-11-30',
    avatar: 'SP', nextSlot: 'Tomorrow 9:00 AM', languages: ['English', 'Hindi', 'Gujarati'],
  },
  {
    id: 'DOC-007', name: 'Dr. Meera Krishnan', specialization: 'Dermatologist',
    department: 'Dermatology', qualification: 'MBBS, MD (Dermatology)',
    experience: 7, availability: 'Available', patientLoad: 19, maxPatients: 28,
    rating: 4.7, consultations: 1876, phone: '+91 98765 43216',
    email: 'meera.krishnan@medicore.hospital', joinDate: '2017-03-08',
    avatar: 'MK', nextSlot: '10:00 AM', languages: ['English', 'Tamil', 'Kannada'],
  },
  {
    id: 'DOC-008', name: 'Dr. Vikram Singh', specialization: 'Emergency Medicine',
    department: 'Emergency', qualification: 'MBBS, MD (Emergency Medicine)',
    experience: 10, availability: 'In Consultation', patientLoad: 28, maxPatients: 30,
    rating: 4.5, consultations: 4521, phone: '+91 98765 43217',
    email: 'vikram.singh@medicore.hospital', joinDate: '2014-08-15',
    avatar: 'VS', nextSlot: 'On Call', languages: ['English', 'Hindi', 'Punjabi'],
  },
  {
    id: 'DOC-009', name: 'Dr. Lakshmi Reddy', specialization: 'Gynecologist',
    department: 'Gynecology', qualification: 'MBBS, MS (OBG), DNB',
    experience: 13, availability: 'On Leave', patientLoad: 0, maxPatients: 25,
    rating: 4.9, consultations: 2198, phone: '+91 98765 43218',
    email: 'lakshmi.reddy@medicore.hospital', joinDate: '2011-02-14',
    avatar: 'LR', nextSlot: 'Returns 20 May', languages: ['English', 'Telugu', 'Hindi'],
  },
  {
    id: 'DOC-010', name: 'Dr. Anand Joshi', specialization: 'Radiologist',
    department: 'Radiology', qualification: 'MBBS, MD (Radiology)',
    experience: 8, availability: 'Available', patientLoad: 10, maxPatients: 20,
    rating: 4.6, consultations: 987, phone: '+91 98765 43219',
    email: 'anand.joshi@medicore.hospital', joinDate: '2016-06-01',
    avatar: 'AJ', nextSlot: '11:30 AM', languages: ['English', 'Hindi', 'Marathi'],
  },
  {
    id: 'DOC-011', name: 'Dr. Fatima Siddiqui', specialization: 'Psychiatrist',
    department: 'Psychiatry', qualification: 'MBBS, MD (Psychiatry)',
    experience: 6, availability: 'Available', patientLoad: 8, maxPatients: 15,
    rating: 4.8, consultations: 743, phone: '+91 98765 43220',
    email: 'fatima.siddiqui@medicore.hospital', joinDate: '2018-09-12',
    avatar: 'FS', nextSlot: '3:00 PM', languages: ['English', 'Hindi', 'Urdu'],
  },
  {
    id: 'DOC-012', name: 'Dr. Ravi Kumar', specialization: 'Nephrologist',
    department: 'Nephrology', qualification: 'MBBS, MD, DM (Nephrology)',
    experience: 15, availability: 'In Consultation', patientLoad: 17, maxPatients: 20,
    rating: 4.7, consultations: 1432, phone: '+91 98765 43221',
    email: 'ravi.kumar@medicore.hospital', joinDate: '2009-04-25',
    avatar: 'RK', nextSlot: '1:30 PM', languages: ['English', 'Hindi', 'Kannada'],
  },
];

export type AvailabilityFilter = 'All' | 'Available' | 'In Surgery' | 'On Leave' | 'Off Duty' | 'In Consultation';
export type ViewMode = 'grid' | 'list';

export interface DoctorFilters {
  search: string;
  department: string;
  specialization: string;
  availability: AvailabilityFilter;
}

export default function DoctorsPage() {
  const [filters, setFilters] = useState<DoctorFilters>({
    search: '',
    department: 'All Departments',
    specialization: 'All Specializations',
    availability: 'All',
  });
  const [viewMode, setViewMode] = useState<ViewMode>('grid');

  const filteredDoctors = useMemo(() => {
    return DOCTORS_DATA.filter((doc) => {
      const q = filters.search.toLowerCase();
      const matchSearch =
        !q ||
        doc.name.toLowerCase().includes(q) ||
        doc.specialization.toLowerCase().includes(q) ||
        doc.department.toLowerCase().includes(q) ||
        doc.id.toLowerCase().includes(q);
      const matchDept = filters.department === 'All Departments' || doc.department === filters.department;
      const matchSpec = filters.specialization === 'All Specializations' || doc.specialization === filters.specialization;
      const matchAvail = filters.availability === 'All' || doc.availability === filters.availability;
      return matchSearch && matchDept && matchSpec && matchAvail;
    });
  }, [filters]);

  return (
    <AppLayout data-component-id="src/app/doctors/page.tsx:164:4" data-component-path="src/app/doctors/page.tsx" data-component-line="164" data-component-end-line="170" data-component-file="page.tsx" data-component-name="AppLayout" data-component-content="%7B%22elementName%22%3A%22AppLayout%22%7D">
      <div data-component-id="src/app/doctors/page.tsx:165:6" data-component-path="src/app/doctors/page.tsx" data-component-line="165" data-component-end-line="169" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-5%22%7D" className="space-y-5">
        <DoctorsHeader data-component-id="src/app/doctors/page.tsx:166:8" data-component-path="src/app/doctors/page.tsx" data-component-line="166" data-component-end-line="166" data-component-file="page.tsx" data-component-name="DoctorsHeader" data-component-content="%7B%22elementName%22%3A%22DoctorsHeader%22%7D" total={DOCTORS_DATA.length} filtered={filteredDoctors.length} viewMode={viewMode} onViewModeChange={setViewMode} />
        <DoctorsFilters data-component-id="src/app/doctors/page.tsx:167:8" data-component-path="src/app/doctors/page.tsx" data-component-line="167" data-component-end-line="167" data-component-file="page.tsx" data-component-name="DoctorsFilters" data-component-content="%7B%22elementName%22%3A%22DoctorsFilters%22%7D" filters={filters} onFiltersChange={setFilters} doctors={DOCTORS_DATA} />
        <DoctorsGrid data-component-id="src/app/doctors/page.tsx:168:8" data-component-path="src/app/doctors/page.tsx" data-component-line="168" data-component-end-line="168" data-component-file="page.tsx" data-component-name="DoctorsGrid" data-component-content="%7B%22elementName%22%3A%22DoctorsGrid%22%7D" doctors={filteredDoctors} viewMode={viewMode} />
      </div>
    </AppLayout>
  );
}
